import { render, staticRenderFns } from "./LeitsystemBzlu.vue?vue&type=template&id=5e4d6d88&scoped=true"
import script from "./LeitsystemBzlu.vue?vue&type=script&lang=js"
export * from "./LeitsystemBzlu.vue?vue&type=script&lang=js"
import style0 from "./LeitsystemBzlu.vue?vue&type=style&index=0&id=5e4d6d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4d6d88",
  null
  
)

export default component.exports